<template>
  <div class="pagination">
    <div class="buttons">
      <button
          @click="changePage(currentPage - 1)"
          :disabled="currentPage === 1"
          class="button blue prev-button"
      >
        <ArrowIcon color="#0E58BC"/>
      </button>
      <button
          @click="changePage(currentPage + 1)"
          :disabled="currentPage === totalPages"
          class="button next-button"
      >
        <span>NEXT PAGE</span>
        <ArrowIcon direction="left" color="#FFF"/>
      </button>
    </div>

    <div class="page-input-container">
      Page
      <input
          type="number"
          v-model.number="inputPage"
          @keyup.enter="goToPage"
          @blur="goToPage"
          :min="1"
          :max="totalPages"
          class="page-input"
      >
      of {{ totalPages }}
    </div>
  </div>
</template>

<script>
import ArrowIcon from "@/components/ArrowIcon.vue";

export default {
  name: 'Pagination',
  components: {ArrowIcon},
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      required: true
    },
    changePage: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      inputPage: this.currentPage
    }
  },
  watch: {
    currentPage(newVal) {
      this.inputPage = newVal;
    }
  },
  computed: {
    totalPages() {
      console.log(this.totalItems, this.perPage, 'totalPages');
      return Math.ceil(this.totalItems / this.perPage);
    }
  },
  methods: {
    goToPage() {
      let page = parseInt(this.inputPage);

      if (isNaN(page) || page < 1) {
        page = 1;
      } else if (page > this.totalPages) {
        page = this.totalPages;
      }

      this.inputPage = page;
      if (page !== this.currentPage) {
        this.changePage(page);
      }
    }
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.buttons {
  display: flex;
  gap: 10px;

  button {
    display: flex;

    &:nth-child(1) {
      justify-content: flex-start;

      svg {
        margin-left: 22px;
      }

     img {
       fill: yellow;

       path {
         fill: yellow;
       }
     }
    }
    &:nth-child(2) {
      max-width: 178px;
      width: 100%;
      position: relative;
      left: -81px;
      padding-right: 0;

      svg {
        margin-right: 27.75px;
      }

      justify-content: flex-end;
      column-gap: 19px;
    }
  }
}

.button {
  position: relative;
  height: 48px;
  border: none;
  border-radius: 24px;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prev-button {
  width: 48px;
  padding: 0;
  background-color: #f0f0f0;
  color: yellow;
}

.next-button {
  background: linear-gradient(to right, #0e58bc, #8fc0ff);
  color: white;
  padding-right: 40px;
}

.arrow-right,
.arrow-left,
.long-arrow-right,
.long-arrow-left{
  &.blue {
    border-left-color: #0E58BC;
    border-right-color: #0E58BC;
    border-top-color: #0E58BC;
  }

  &.white {
    border-left-color: #FFFFFF;
    border-right-color: #FFFFFF;
    border-top-color: #FFFFFF;
  }

  display: block;
  margin: 30px auto;
  width: 25px;
  height: 25px;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
}
.arrow-right,
.long-arrow-right{
  transform: rotate(135deg);
}

.arrow-left,
.long-arrow-left{
  transform: rotate(-45deg);
}
.long-arrow-right,
.long-arrow-left {

  &.blue {
    &::after {
      background-color: #0e58BC;
    }
  }

  &.white {
    &::after {
      background-color: #FFFFFF;
    }
  }

  &::after {
    content: "";
    display: block;
    width: 2px;
    height: 45px;
    background-color: black;
    transform: rotate(-45deg) translate(15px, 4px);
    left: 0;
    top: 0;
  }
}

.page-input-container {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  line-height: 19px;
  color: #818990;
  font-family: 'Open Sans', sans-serif;
}

.page-input {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 5px;
  text-align: center;
  border: 1px solid #ddd;
}

.page-input:focus {
  outline: none;
  border-color: #999;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .pagination {
    flex-direction: column;
    gap: 10px;
  }

  .page-input-container {
    order: -1;
    margin-bottom: 10px;
  }
}
</style>